export const REGISTERED = 'registered'
export const APPROVED = 'approved'
export const PASSED = 'passed'
